import { ArgumentValidator } from "./argument-validator";

/**
 * A helper class for opening a new window and setting its URL.
 * This class is useful for scenarios where you need to open a new window
 * and ensure that the URL is set correctly, handling cases where popup blockers
 * might prevent the window from opening.
 */
export class WindowOpener {

    tryClose(window: Window | null) {

        // If the window is not null, attempt to close it.
        if (window) {

            window.close();
        }
    }

    public tryOpenEmptyWindow(target = '_blank', features?: string): Window | null {

        const emptyWindow = window.open('', target, features);

        // If the new window was successfully opened, return it.
        if (emptyWindow) {

            return emptyWindow;
        }

        // If the popup blocker prevented the window from opening, return null.
        return null;
    }

    public tryRedirect(window: Window | null, url: string): void {

        ArgumentValidator.notNullOrEmpty(url, `url`);

        // If a popup blocker still intervened, display an error message.
        if (!window) {

            alert('Det gick inte att öppna ett nytt fönster. Kontrollera att popup-fönster är tillåtna för denna sida i din webbläsare och försök igen.');

            return;
        }

        // Set the URL for the given window.
        window.location.href = url;
    }
}